import { apiCallSolveApprovalData } from "../../api/approve-reject-api/api-call-solve-approval-data";
import { TCorePage } from "../../Types";
import getCleanPoolStore from "../core/core-clean-pool";
import getCorePersonalStore from "../core/core-personal-store";
import getCorePopUpStore from "../core/core-popup-store";
import getUserAdvancedStore from "../user-store/advanced-store";
import getSuccessApproveRejectStatus from "./success-approve-reject-status";

const approveUserPictureOnDatabase = async (
  userId: number,
  userUUID: string,
  from: TCorePage,
  imageID: string,
  resolvingPendindData: boolean
) => {
  const adminUserId = getCorePersonalStore().user.get().id;
  const { status, code } = await apiCallSolveApprovalData({
    descriptionID: -1,
    adminUserId,
    userUUID,
    action: "approve_picture_album",
    from,
    imageID,
    resolvingPendindData
  });
  if (status === "OK") {
    getSuccessApproveRejectStatus().approveUserPictureClient(
      from,
      userId,
      imageID,
      resolvingPendindData
    );
    getUserAdvancedStore().shouldChangeFromClientSide.set(true);
  } else {
    if (code === "NO_LONGER_ACTIVE_POOL") {
      await getCleanPoolStore().automaticCleanPool({ type: "APPROVAL" });
    }
    getCorePopUpStore().showAlertMessage(code);
  }
};

export default approveUserPictureOnDatabase;
